import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          Created by ENCSS &copy; {new Date().getFullYear()}. If you like this web app and want to support me building more cool tools, <Link to="/donate" className="footer-link">click here</Link>. For feedback or bugs, please reach out to lau_eric on Discord!
        </p>
      </div>
    </footer>
  );
};

export default Footer;
